import request from '@/utils/request'
import selfRequest from '@/utils/selfRequest'

export const login_mobile = function(payload) {
  return request({
    url: '/v1/cp168/wap/login',
    method: 'post',
    data: payload
  })
}

export const register_mobile = function(payload) {
  return request({
    url: '/v1/cp168/wap/register',
    method: 'post',
    data: payload
  })
}

export const findPwdValidate_mobile = function(payload) {
  return request({
    url: '/v1/cp168/wap/findPassword/validate',
    method: 'get',
    params: payload
  })
}

export const findPwdNewPwd_mobile = function(payload) {
  return request({
    url: '/v1/cp168/wap/findPassword/newPassword',
    method: 'put',
    data: payload
  })
}

export const getUserInfo_mobile = function() {
  return request({
    url: `/v1/cp168/wap/me?call=${new Date().getTime()}`,
    method: 'get'
  })
}

export const getBasicInfo_mobile = function() {
  return request({
    url: `/v1/cp168/wap/me/basicInfo?call=${new Date().getTime()}`,
    method: 'get'
  })
}

export const editBasicInfo_mobile = function(payload) {
  return request({
    url: '/v1/cp168/wap/me/basicInfo',
    method: 'put',
    data: payload
  })
}

export const getPredictionReport_mobile = function(query) {
  return request({
    url: '/v1/cp168/wap/me/predictionReport',
    method: 'get',
    params: query
  })
}

export const getScoreHistories_mobile = function(query) {
  return request({
    url: '/v1/cp168/wap/me/scoreHistories',
    method: 'get',
    params: query
  })
}

export const sendFeedback_mobile = function(payload) {
  return request({
    url: '/v1/cp168/wap/setting/feedback',
    method: 'post',
    data: payload
  })
}

export const fileUpload_mobile = function(payload) {
  return request({
    url: '/v1/cp168/wap/file',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: payload
  })
}

export const verifyCaptcha = function(query) {
  return selfRequest({
    url: '/verify',
    method: 'get',
    params: query
  })
}
